import { useEffect, useState } from "react";
import "../../Assets/css/paymentOptions.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Axios from "axios";
import Swal from "sweetalert2";
import { getDomain } from "../../Utilities/utils";
import { TRANSFER_DATA_API_ENDPOINT } from "../apiConfig";
import { THANK_YOU_PAGE_ROUTE } from "../routes";
import downloadPolicyHelper from "./Helpers/downloadPolicyHelper";

const usePolicyStatusPage = () => {
  const { transferDataId } = useParams();
  const { state } = useLocation();
  const { policyNumber, proposalNumber } = state ?? {};

  const [transferData, setTransferData] = useState({});
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    // Get transfer data
    const domain = getDomain();
    Axios.get(`${domain}${TRANSFER_DATA_API_ENDPOINT}/${transferDataId}/`).then(
      (response) => {
        console.log("transfer data response", response);
        setTransferData(response.data);
      }
    );
  }, [transferDataId]);

  const backButtonHandler = () => {
    navigate(-1);
  };

  const downloadPolicy = () => {
    if (!policyNumber && !transferData?.policy_number) {
      Swal.fire({
        icon: "error",
        title: "Soemthing went wrong..",
        position: "center",
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      });
      return;
    }
    // Call helper method
    downloadPolicyHelper(
      setLoading,
      transferData,
      policyNumber || transferData?.policy_number,
      navigateToThankYouPage
    );
  };

  const navigateToThankYouPage = () => {
    navigate(THANK_YOU_PAGE_ROUTE);
  };

  return {
    transferData,
    proposalNumber: proposalNumber || transferData?.proposal_number,
    downloadPolicy,
    loading,
    backButtonHandler,
  };
};

export default usePolicyStatusPage;
